// HOMLAND Glossary — shared behaviour for the hub and term-detail sections
// (sections/homland-glossary-hub.liquid, sections/homland-glossary-term.liquid)
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.hl-glossary .faq-item').forEach(function (item) {
    var question = item.querySelector('.faq-question');
    if (!question) return;
    question.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      item.closest('.faq').querySelectorAll('.faq-item.open').forEach(function (open) {
        if (open !== item) {
          open.classList.remove('open');
          open.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('open', !isOpen);
      question.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  // Hub: category / A-Z view toggle
  var viewToggle = document.querySelector('.hl-glossary .view-toggle');
  if (viewToggle) {
    var catView = document.querySelector('.hl-glossary .cat-view');
    var azView = document.querySelector('.hl-glossary .az-view');
    var jump = document.querySelector('.hl-glossary .cluster-jump');
    viewToggle.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-view]');
      if (!btn) return;
      viewToggle.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var view = btn.getAttribute('data-view');
      if (view === 'az') {
        catView.classList.add('hidden');
        azView.classList.add('active');
        if (jump) jump.style.display = 'none';
      } else {
        catView.classList.remove('hidden');
        azView.classList.remove('active');
        if (jump) jump.style.display = '';
      }
    });
  }

  // Hub: live search filter across both views
  var searchInput = document.querySelector('.hl-glossary [data-glossary-search]');
  if (searchInput) {
    var allItems = Array.prototype.slice.call(document.querySelectorAll('.hl-glossary [data-term-name]'));
    var noResults = document.querySelector('.hl-glossary .no-results');
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim().toLowerCase();
      var visibleCount = 0;
      allItems.forEach(function (el) {
        var name = el.getAttribute('data-term-name').toLowerCase();
        var match = name.indexOf(q) !== -1;
        el.style.display = match ? '' : 'none';
        if (match) visibleCount++;
      });
      document.querySelectorAll('.hl-glossary .cluster-section, .hl-glossary .az-group').forEach(function (group) {
        var visible = group.querySelectorAll('[data-term-name]:not([style*="display: none"])').length;
        group.style.display = visible ? '' : 'none';
      });
      if (noResults) noResults.classList.toggle('show', visibleCount === 0);
    });
  }

  // Term page: auto-build the sidebar "On this page" TOC from the article's h2s
  var toc = document.querySelector('.hl-glossary [data-term-toc]');
  var article = document.querySelector('.hl-glossary [data-term-article]');
  if (toc && article) {
    var headings = Array.prototype.slice.call(article.querySelectorAll('h2[id]'));
    headings.forEach(function (heading) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = heading.textContent;
      li.appendChild(a);
      toc.appendChild(li);
    });
  }
});
